import { AfterViewInit, Directive, ElementRef, HostListener, Input, inject } from "@angular/core"

type FallbackType = "generic" | "user"

@Directive({
	selector: "img[appImgFallback]",
	standalone: true
})
export class ImgFallbackDirective implements AfterViewInit {
	private readonly fallbackMap: Record<FallbackType, string> = {
		generic: "assets/images/placeholder.svg",
		user: "assets/images/placeholder-user.svg"
	}

	fallbackSrc = this.fallbackMap.generic

	@Input()
	set appImgFallback(value: FallbackType | undefined | null | "") {
		this.fallbackSrc = this.getFallbackFor(value === "user" ? "user" : "generic")
		this.ensureInitialSrc()
	}

	private readonly host = inject<ElementRef<HTMLImageElement>>(ElementRef)

	ngAfterViewInit(): void {
		this.ensureInitialSrc()
	}

	@HostListener("error")
	onError() {
		this.ensureFallback()
	}

	private normalize(value: unknown): string {
		return typeof value === "string" ? value.trim() : ""
	}

	private getFallbackFor(key: FallbackType): string {
		return this.fallbackMap[key] || this.fallbackMap.generic
	}

	private currentSrc(): string {
		const img = this.host.nativeElement
		return this.normalize(img.getAttribute("src") ?? img.src)
	}

	private setSrcIfDifferent(value: string): void {
		const img = this.host.nativeElement
		if (this.currentSrc() !== value) {
			img.src = value
		}
	}

	private ensureInitialSrc(): void {
		if (!this.currentSrc()) {
			this.setSrcIfDifferent(this.fallbackSrc)
		}
	}

	private ensureFallback(): void {
		this.setSrcIfDifferent(this.fallbackSrc)
	}
}
